import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const LocationOutline = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.048}
      d="M12 2a7.866 7.866 0 0 0-7.857 7.857 7.8 7.8 0 0 0 1.716 4.888c.05.067.1.131.116.15l5.208 6.141a1.07 1.07 0 0 0 1.634 0l5.211-6.145.248-.323a7.8 7.8 0 0 0 1.581-4.71A7.867 7.867 0 0 0 12 2m0 10.714A2.857 2.857 0 1 1 12 7a2.857 2.857 0 0 1 0 5.714"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(LocationOutline) as SvgIcon;
export { ForwardRef as ReactComponent };
